import { makeStyles } from "@material-ui/core/styles";

import {
  DEFAULT_BOX_SHADOW,
  PRIMARY_BACKGROUND,
  PRIMARY_COLOR_BUTTON,
} from "App/constants/theme";

const useTabStyle = makeStyles({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "97%",
    margin: "0 auto",
  },
  rootTab: {
    flexGrow: 1,
    backgroundColor: "transparent",
    width: "100%",
  },
  tabs: {
    backgroundColor: "#fff",
    color: PRIMARY_COLOR_BUTTON,
    borderRadius: 8,
    height: "100%",
  },
  tab: {
    border: `1px solid ${PRIMARY_COLOR_BUTTON}`,
  },
  selected: {
    backgroundColor: PRIMARY_COLOR_BUTTON,
    color: "white",
  },
  appbar: {
    boxShadow: "0px 0px 0px 0px #fff",
    borderRadius: 6,
    height: "auto",
  },
  fixedTab:{
    flexWrap: 'wrap',
    height: "100%",
  },
  scrollAbel:{
    height: "100%",
  }
});

export default useTabStyle;
